import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "s-modal__header-title" }
const _hoisted_2 = { class: "s-modal__body" }
const _hoisted_3 = { class: "s-modal__footer full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "nativeDialog",
    persistent: "",
    class: "s-modal__wrapper"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["s-modal", _ctx.classes])
      }, {
        default: _withCtx(() => [
          (_ctx.withHeader)
            ? (_openBlock(), _createBlock(_component_q_toolbar, {
                key: 0,
                class: "s-modal__header-wrapper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_toolbar_title, { class: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1),
                      _renderSlot(_ctx.$slots, "after-title")
                    ]),
                    _: 3
                  }),
                  (_ctx.rightIconClose)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        "no-caps": "",
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: "",
                        color: "brand",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }, null, 512)), [
                        [_directive_close_popup]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "footer")
          ])
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }, 512))
}